export const TEXT_BASE = "text-[10px] 3xl:text-[15px] 4xl:text-lg";
